// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { TextField, CircularProgress, Switch, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Paper, Button } from '@mui/material';
import '../Styles/Pages/FeaturesPage.css';
// import ServerDetailsComponent from '../Components/Details/ServerDetailsComponent'; // Import ServerDetails
// import SearchComponent from '../Components/Search/SearchComponent'; // Import SearchComponent

const FeaturesPage = () => {
  // const [featureList, setFeatureList] = useState([]);
  // const [casinoList, setCasinoList] = useState([]);
  // const [filteredList, setFilteredList] = useState([]);
  // const [search, setSearch] = useState('');
  // const [headers, setHeaders] = useState([
  //   { text: "OperatorName", value: "operatorName", collapse: true },
  //   { text: "BrandName", value: "brandName", visible: false },
  //   { text: "ProductName", value: "productName", collapse: false },
  //   { text: "ServerID", value: "productID", collapse: false },
  //   { text: "OperatorID", value: "operatorID", collapse: true },
  // ]);
  // const [loading, setLoading] = useState(false);
  // const [showFieldSelector, setShowFieldSelector] = useState(false);
  // const [advancedSearch, setAdvancedSearch] = useState(false); // To toggle advanced search

  // // Handle loading of features and casino list
  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const featureResponse = await axios.get('features/featurelist');
  //       const casinoResponse = await axios.get('features');

  //       setFeatureList(featureResponse.data);
  //       setCasinoList(casinoResponse.data);
  //       setFilteredList(casinoResponse.data);

  //       // Add features dynamically to headers
  //       const newHeaders = [...headers];
  //       featureResponse.data.forEach(feature => {
  //         newHeaders.push({ text: feature.toString(), value: feature.toString(), visible: true });
  //       });
  //       setHeaders(newHeaders);
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //     setLoading(false);
  //   };

  //   fetchData();
  // }, []);

  // // Filtering logic based on search input
  // useEffect(() => {
  //   const filtered = casinoList.filter((server) => {
  //     return (
  //       server.productName.toLowerCase().includes(search.toLowerCase()) ||
  //       server.productID.toString().includes(search)
  //     );
  //   });
  //   setFilteredList(filtered);
  // }, [search, casinoList]);

  // const handleSearchChange = (e) => {
  //   setSearch(e.target.value);
  // };

  // const toggleFieldSelector = () => {
  //   setShowFieldSelector(!showFieldSelector);
  // };

  // const toggleAdvancedSearch = () => {
  //   setAdvancedSearch(!advancedSearch);
  // };

  // const emptyOrUnicode = (val) => (val === "" || val == null ? "❌" : val);

  // const booleanUnicode = (val) => (val === true ? "✔️" : "❌");

  // const filterFeatures = (features) => {
  //   return features.filter((feature) => {
  //     return headers.find((h) => h.text === feature.name).visible;
  //   });
  // };

  return (
    <div>Reserved for v2</div>
  );
  //   <div>
  //     {/* Toggle Advanced Search and Simple Search */}
  //     {advancedSearch ? (
  //       <SearchComponent
  //         searchParent={(searchList) => console.log(searchList)} // Pass logic for search results
  //         searchToggle={toggleAdvancedSearch}
  //         exportData={() => console.log('Export Data')}
  //         toggleFields={toggleFieldSelector}
  //       />
  //     ) : (
  //       <div>
  //         <TextField
  //           label="Search ServerID / ProductName"
  //           variant="outlined"
  //           value={search}
  //           onChange={handleSearchChange}
  //           style={{ marginBottom: '20px' }}
  //         />
  //         <Button onClick={toggleAdvancedSearch} variant="contained" color="primary">
  //           Advanced Search
  //         </Button>
  //         <Button onClick={toggleFieldSelector} variant="contained" style={{ marginLeft: '10px' }}>
  //           Toggle Field Selector
  //         </Button>
  //       </div>
  //     )}

  //     {/* Field Selector */}
  //     {showFieldSelector && (
  //       <div>
  //         {headers.map((header, index) => (
  //           <div key={index}>
  //             <Switch
  //               checked={header.visible}
  //               onChange={() => {
  //                 const newHeaders = [...headers];
  //                 newHeaders[index].visible = !newHeaders[index].visible;
  //                 setHeaders(newHeaders);
  //               }}
  //             />
  //             <span>{header.text}</span>
  //           </div>
  //         ))}
  //       </div>
  //     )}

  //     {/* Table of Features */}
  //     <TableContainer component={Paper} className="table-container">
  //       <Table>
  //         <TableHead>
  //           <TableRow>
  //             {headers
  //               .filter((header) => header.visible || !header.collapse)
  //               .map((header, index) => (
  //                 <TableCell key={index}>{header.text}</TableCell>
  //               ))}
  //           </TableRow>
  //         </TableHead>
  //         <TableBody>
  //           {loading ? (
  //             <TableRow>
  //               <TableCell colSpan={headers.length}>
  //                 <CircularProgress />
  //               </TableCell>
  //             </TableRow>
  //           ) : (
  //             filteredList.map((item, index) => (
  //               <TableRow key={index}>
  //                 <TableCell>{emptyOrUnicode(item.operatorName)}</TableCell>
  //                 {headers.find((header) => header.text === "BrandName").visible && (
  //                   <TableCell>{emptyOrUnicode(item.brandName)}</TableCell>
  //                 )}
  //                 <TableCell>{emptyOrUnicode(item.productName)}</TableCell>
  //                 <TableCell>{emptyOrUnicode(item.productID)}</TableCell>
  //                 <TableCell>{emptyOrUnicode(item.operatorID)}</TableCell>
  //                 {filterFeatures(item.features).map((feature, index) => (
  //                   <TableCell key={index}>{booleanUnicode(feature.isOn)}</TableCell>
  //                 ))}
  //               </TableRow>
  //             ))
  //           )}
  //         </TableBody>
  //       </Table>
  //     </TableContainer>

  //     {/* Server Details Component */}
  //     {/* This component could be shown conditionally on some row click or other trigger */}
  //     {/* <ServerDetailsComponent serverDetails={selectedServerDetails} closeDialog={() => {}} /> */}
  //   </div>
  // );
};

export default FeaturesPage;
